import React from 'react';
import './footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <h5>Shubham Jindal 🐥</h5>
    </footer>
  )
}